import socialsPlatform from "fragments/socialsPlatform"
import gql from "graphql-tag"

const GET_SOCIALS_PLATFORMS = gql`
  ${socialsPlatform}

  query getSocialsPlatforms(
    $socialsPlatformsGetInput: SocialsPlatformsGetInput
  ) {
    getSocialsPlatforms(socialsPlatformsGetInput: $socialsPlatformsGetInput) {
      ...SocialsPlatform
    }
  }
`

export default GET_SOCIALS_PLATFORMS
